import {Component} from '@angular/core';
import {BaseSupportModalComponent} from "./base_support.component";

@Component({
	templateUrl: './set_freemium_user.component.html'
})
export class SetFreemiumUserModalComponent extends BaseSupportModalComponent {
	userId: string;
	email: string;
	allowFreemium: boolean;

	async ok() {
		await this.supportService.setFreemiumUser(this.userId, !this.allowFreemium, this.spreader.base.comment).toPromise();

		this.execute();
	}
}
